import { Link } from "react-router-dom";
import { textChooser } from "../../common/util/textChooser";
import { TextIcon } from "../../common/components/text_icon";
import { LogoutBtn } from "../../common/components/controls/logout";
import { useUser } from "../../common/hooks/User";
import { ProfileSummary } from "./profileSummary";
import { Icon } from "../../common/components/icons";
import { UserAvatar } from "../../common/components/avatar/userAvatar";
import "./profile.scss";
import { useEffect, useState } from "react";
import { getCountries } from "../../common/apis/public.api";

export const Profile = () => {
  const userData = useUser().getDataAll();
  const [countries, setCountries] = useState();

  async function getCountriesList() {
    const countriesList = await getCountries();

    setCountries(countriesList);
  }

  useEffect(() => {
    getCountriesList()
  }, []);

  return (
    <div className="page -profile">
      <h1 className="page-title">
        {textChooser("txt57")}
      </h1>
      <div className="profile-intro">
        <div className="block -left">
          <UserAvatar size={"md"} squared />
        </div>
        <div className="block -center">
          <p>{userData?.name ?? ""} {userData?.lastName ?? ""}</p>
          <TextIcon type="location" text={"Lima, Peru"} />
        </div>
        <div className="block -right">
          <Link to={"/profile-edit"} className={"link-btn"}>
            <Icon type={"edit"} />
          </Link>
          <LogoutBtn />
        </div>
      </div>
      <div className="profile-section">
        <ProfileSummary countries={countries} />
      </div>
    </div>
  )
}